import { render, staticRenderFns } from "./reciboPDF.vue?vue&type=template&id=feb29a6e&scoped=true&"
import script from "./reciboPDF.vue?vue&type=script&lang=js&"
export * from "./reciboPDF.vue?vue&type=script&lang=js&"
import style0 from "./reciboPDF.vue?vue&type=style&index=0&id=feb29a6e&lang=scss&scoped=true&"
import style1 from "./reciboPDF.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb29a6e",
  null
  
)

export default component.exports